import type { CardId } from '@voll-intelligence/domain';

import { t } from '@web/i18n';
import { useCardCustomerProfile, useCardDetail } from '@web/ui/core/hooks';
import { CustomerAvatar, Section } from '@web/ui/core/molecules';

import { ContactRows } from './contact_rows';

/**
 * O bloco Cliente da coluna lateral em tela cheia: quem é o viajante (avatar,
 * nome, empresa, do card) e como falar com ele (contato e milhas, do perfil).
 * Só leitura; mesmos estados da aba Identidade.
 */
export function CustomerContactCard({ cardId }: Readonly<{ cardId: CardId }>): React.JSX.Element {
  const detail = useCardDetail(cardId).data;
  const profileState = useCardCustomerProfile(cardId);
  return (
    <div className="flex flex-col gap-4 px-5 py-4" data-testid="customer-contact-card">
      {detail ? (
        <header className="flex items-center gap-3">
          <CustomerAvatar name={detail.customer.name} vip={detail.customer.vip} size="lg" />
          <div className="flex min-w-0 flex-col gap-0.5">
            <span className="truncate text-base font-medium text-foreground">
              {detail.customer.name}
            </span>
            <span className="truncate text-meta text-muted-foreground">{detail.company.name}</span>
          </div>
        </header>
      ) : null}
      <Section title={t('card.side.customer.title')}>
        <ContactRows state={profileState} />
      </Section>
    </div>
  );
}
